import React, { useContext } from "react";
import {
  HiMapPin,
  HiPhone,
  HiEnvelope,
  HiClock,
  HiStar,
} from "react-icons/hi2";
import "../../../assets/css/customer/components/ShopDetailPage.css";
import MyContext from "../../../contexts/AppContext";

const ShopDetailPage = ({ shopData }) => {
  const { baseUrlForFiles, selectedShop } = useContext(MyContext);

  const shop = selectedShop || {};

  return (
    <div className="shop-detail-page">
      <div className="shop-detail-card">
        {/* Shop Image */}
        <div className="shop-detail-image">
          <img
            src={
              shop.shop_image
                ? `${baseUrlForFiles}/${shop.shop_image}`
                : "/default-shop.png"
            }
            alt={shop.store_name}
          />
        </div>

        {/* Shop Info */}
        <div className="shop-detail-content">
          <div className="shop-detail-header">
            <h1 className="shop-detail-name">{shop.store_name}</h1>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div className="shop-detail-rating">
                <HiStar
                  size={24}
                  style={{ fill: "#ffc107", color: "#ffc107" }}
                />
                <span className="rating-value">
                  {shop.reviews_avg_rating
                    ? parseFloat(shop.reviews_avg_rating)
                        .toFixed(1)
                        .replace(".0", "")
                    : "0"}
                </span>{" "}
                <span className="rating-count">
                  ({shop.products_count || 0} products)
                </span>
              </div>
            </div>
          </div>

          <p className="shop-detail-description">{shop.description}</p>

          {/* Contact info */}
          <div className="shop-contact-info">
            <div className="contact-item">
              <HiMapPin className="contact-icon" size={20} />
              <span>
                {shop.business_address}, {shop.city}
              </span>
            </div>
            <div className="contact-item">
              <HiPhone className="contact-icon" size={20} />
              <span>{shop.phone || "N/A"}</span>
            </div>
            <div className="contact-item">
              <HiEnvelope className="contact-icon" size={20} />
              <span>{shop.business_email || shop.email}</span>
            </div>
            <div className="contact-item">
              <HiClock className="contact-icon" size={20} />
              <span>Mon-Sat: 10:00 AM - 8:00 PM</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopDetailPage;
